/**
 * partyPrintables — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {A4, tagline, chips, type ToilePack} from './data'

export const partyPrintablesPack: ToilePack = {
    slug: 'party-printables',
    category: 'party',
    name: 'Party printables',
    tagline: tagline('printables', 'themes', 'formats'),
    chips: chips('themes', 'formats'),
    ratio: A4,
    readings: [
        {key: 'dino', label: 'Dinosaur', subject: 'dinosaur birthday party, green and orange, a friendly T-rex'},
        {key: 'baby', label: 'Woodland baby', subject: 'woodland baby shower, sage and cream, fox and ferns'},
        {key: 'garden', label: 'Garden tea', subject: 'garden tea party, pastel florals, teacups and butterflies'},
    ],
    styles: [
        {key: 'invite', label: 'Invitation', style: 'party invitation card, blank panel for details', palette: 'theme palette', framing: 'vertical card'},
        {key: 'banner', label: 'Banner', style: 'bunting banner, triangular flags in a row', palette: 'theme palette', framing: 'row of flags'},
        {key: 'topper', label: 'Cupcake toppers', style: 'cupcake-topper sheet, six round badges', palette: 'theme palette', framing: '2×3 grid, cut lines'},
    ],
    directions: ['a space theme instead', 'in black and gold', 'for a grown-up party'],
}
